var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.83 6.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.36,1H.48A.48.48,0,0,1,0,.51.49.49,0,0,1,.48,0H7.36a.49.49,0,0,1,.47.51.48.48,0,0,1-.47.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.36,3.9H.48A.49.49,0,0,1,0,3.39a.48.48,0,0,1,.48-.5H7.36a.48.48,0,0,1,.47.5.49.49,0,0,1-.47.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.36,6.79H.48a.51.51,0,0,1,0-1H7.36a.51.51,0,0,1,0,1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.72c3c06f3573fcad92f75ba35be00ed8.svg";
export { ForwardRef as ReactComponent };